export function createValueConverter(dynamicOptions, isMulti, getOptionValue) {
	return function valueToSelectValue(val) {
		if (!val) return isMulti ? [] : null;

		if (isMulti) {
			if (Array.isArray(val)) {
				return val
					.map((v) => {
						if (typeof v === "object" && v !== null) return v;
						return dynamicOptions.find((opt) => getOptionValue(opt) === v) || null;
					})
					.filter(Boolean);
			}
			const found = dynamicOptions.find((opt) => getOptionValue(opt) === val);
			return found ? [found] : [];
		}

		if (typeof val === "object" && val !== null) return val;
		return dynamicOptions.find((opt) => getOptionValue(opt) === val) || null;
	};
}

export function defaultFormatOutput(selected, isMulti, getOptionValue) {
	if (!selected) return null;
	if (isMulti) {
		return Array.isArray(selected) ? selected.map((s) => getOptionValue(s)) : [];
	}
	return getOptionValue(selected);
}
